import { get, startsWith } from 'lodash';

const locale = get(window, ['TIS', 'locale'], 'en');

export const isFrench = () => locale === 'fr' || startsWith(locale, 'fr-');
